export class SellerEnrollmentInterest {
    public sellerEnrollmentInterestKey: string;
    public refRelationshipKey: string;
    public reasonCode: string;
    public reasonText: string;
    public refUserKey: string;
    constructor(obj?: {
       sellerEnrollmentInterestKey?: string;
       refRelationshipKey?: string;
       reasonCode?: string;
       reasonText?: string;
       refUserKey?: string;
    }) {
        if (obj != null) {
            this.sellerEnrollmentInterestKey = typeof obj.sellerEnrollmentInterestKey === 'undefined' ? this.sellerEnrollmentInterestKey : obj.sellerEnrollmentInterestKey;
            this.refRelationshipKey = typeof obj.refRelationshipKey === 'undefined' ? this.refRelationshipKey : obj.refRelationshipKey;
            this.reasonCode = typeof obj.reasonCode === 'undefined' ? this.reasonCode : obj.reasonCode;
            this.reasonText = typeof obj.reasonText === 'undefined' ? this.reasonText : obj.reasonText;
            this.refUserKey = typeof obj.refUserKey === 'undefined' ? this.refUserKey : obj.refUserKey;
        }
    }
}
